function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import PropTypes from 'prop-types';
import classNames from 'classnames';
/**
 * Bulma viewports
 * @type {string[]}
 */

var VIEWPORTS = ['mobile', 'tablet', 'desktop', 'widescreen', 'fullhd', 'touch'];
/**
 * Display modifier values
 * @type {string[]}
 */

var DISPLAYS = ['block', 'flex', 'inline', 'inline-block', 'inline-flex'];
/**
 * Text size modifier values
 * @type {number[]}
 */

var TEXT_SIZES = [1, 2, 3, 4, 5, 6];
var TEXT_ALIGNMENTS = ['centered', 'justified', 'left', 'right'];
var responsiveModifierPropTypes = VIEWPORTS.reduce(function (allViewports, currentViewport) {
  var modifierProps = PropTypes.shape({
    display: PropTypes.oneOf(DISPLAYS),
    hide: PropTypes.bool,
    textSize: PropTypes.oneOf(TEXT_SIZES),
    textAlignment: PropTypes.oneOf(TEXT_ALIGNMENTS)
  });
  var viewportSpecificPropName = "".concat(currentViewport, "Only");
  allViewports.propTypes[currentViewport] = modifierProps;
  allViewports.defaultProps[currentViewport] = undefined;
  allViewports.propTypes[viewportSpecificPropName] = modifierProps;
  allViewports.defaultProps[viewportSpecificPropName] = undefined;
  return allViewports;
}, {
  propTypes: {
    display: PropTypes.oneOf(DISPLAYS)
  },
  defaultProps: {
    display: undefined
  }
});
/**
 * Return Bulma modifier classes from given component props
 * @param props
 */

var classNamesFromProps = function classNamesFromProps(props) {
  return Object.keys(props).reduce(function (classNamesObject, propName) {
    var maybeViewportName = propName.replace('Only', ''); // each viewport has two props:
    // mobile, mobileOnly; desktop, desktopOnly, etc.
    // this checks if propName is a responsive modifier prop

    if (VIEWPORTS.includes(maybeViewportName) && props[propName]) {
      var currentViewport = maybeViewportName;
      var _props$propName = props[propName],
          _props$propName$displ = _props$propName.display,
          display = _props$propName$displ === void 0 ? '' : _props$propName$displ,
          _props$propName$hide = _props$propName.hide,
          hide = _props$propName$hide === void 0 ? false : _props$propName$hide,
          _props$propName$textS = _props$propName.textSize,
          textSize = _props$propName$textS === void 0 ? 0 : _props$propName$textS,
          _props$propName$textA = _props$propName.textAlignment,
          textAlignment = _props$propName$textA === void 0 ? '' : _props$propName$textA;

      if (propName.includes('Only')) {
        // current modifiers are viewport specific
        classNamesObject["is-".concat(display, "-").concat(currentViewport, "-only")] = display;
        classNamesObject["is-hidden-".concat(currentViewport, "-only")] = hide;
        classNamesObject["has-text-".concat(textAlignment, "-").concat(currentViewport, "-only")] = textAlignment;
        classNamesObject["is-size-".concat(textSize, "-only")] = textSize;
      } else {
        classNamesObject["is-".concat(display, "-").concat(currentViewport)] = display;
        classNamesObject["is-hidden-".concat(currentViewport)] = hide;
        classNamesObject["has-text-".concat(textAlignment, "-").concat(currentViewport)] = textAlignment;
        classNamesObject["is-size-".concat(textSize)] = textSize;
      }
    }

    return classNamesObject;
  }, _defineProperty({}, "is-".concat(props.display), props.display));
};

export default _objectSpread(_objectSpread({}, responsiveModifierPropTypes), {}, {
  classnames: function classnames(props) {
    return classNames(classNamesFromProps(props));
  },
  clean: function clean(props) {
    return Object.keys(props).reduce(function (cleanedProps, propName) {
      if (!VIEWPORTS.includes(propName.replace('Only', ''))) {
        cleanedProps[propName] = props[propName];
      }

      return cleanedProps;
    }, {});
  }
});